var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerStandard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.01 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.98,
    y: 9.83,
    width: 36.04,
    height: 36.04,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 16.88,
    width: 16.77,
    height: 16.77,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marker-standard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.59,
    cy: 26.94,
    r: 12.57,
    fill: "#e2ebb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.07,16.62A13.41,13.41,0,1,0,19.73,39.21L22.58,43l2.86-3.81a13.41,13.41,0,0,0,6.63-22.59ZM24.76,37.53l-.33.07-1.85,2.45L20.74,37.6l-.33-.07a11.63,11.63,0,1,1,4.35,0Z",
    fill: "#62c333"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#62c234",
    d: "M27.55,23.65a3.43,3.43,0,0,0-1.23.22,10,10,0,0,1-.69-2A2.26,2.26,0,0,0,23.43,20a.5.5,0,0,0,0,1,1.26,1.26,0,0,1,1.11.66l0,0-.15.26-.77,1.3H19.45l-.23-.59h.1a.49.49,0,0,0,0-1h-1.7a.49.49,0,0,0,0,1h.54l.43,1.08A3.42,3.42,0,1,0,20.9,28a4.15,4.15,0,0,0,.11-.48h.9a.47.47,0,0,0,.42-.24L24.91,23a14.86,14.86,0,0,0,.55,1.39,3.4,3.4,0,1,0,2.09-.72Zm-9.93,3.91H20a2.43,2.43,0,1,1,0-1H17.62a.5.5,0,0,0,0,1Zm4-1H21a3.41,3.41,0,0,0-1.06-2,.14.14,0,0,0,0-.06l-.09-.22H23Zm5.92,2.94a2.44,2.44,0,0,1-1.65-4.24c.38.71.79,1.41,1.24,2.08a.5.5,0,0,0,.69.11.5.5,0,0,0,.12-.67,19.67,19.67,0,0,1-1.2-2,2.44,2.44,0,1,1,1.59,4.61,2.35,2.35,0,0,1-.79.14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerStandard);
export default __webpack_public_path__ + "static/media/marker-standard.e2b3b129b033418b28592e5a5187e078.svg";
export { ForwardRef as ReactComponent };